import { useFetchNewsBySlug } from "../hooks/useFetchNewsBySlug"
import { MediaShow } from "../../../ui/organisms/ShowMedia"


export const ShowActus = () => {
    return (
        <MediaShow 
            type="actus"
            fetchHook={ useFetchNewsBySlug } 
        />
    )
}